export default "__VITE_ASSET__DnieaGWx__"